export default "/images/vendor/flag-icon-css/flags/4x3/ad.svg?ad7b28b8809b2680a778487cf7f6a148";